import React, { useState } from "react";
import "./LoginPage.css";
import * as authService from '../../_services/authServices'
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader';

import { toast } from "react-hot-toast";

import { useUser } from "../../context/UserContext";

const RegisterUser = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    emailAddress: "",
    mobileNumber: ""
  });

  const { user } = useUser();

  if(user) {
    navigate("/choose-profile", {replace: true})
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
  
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
  
    setLoading(true);
    setValidated(true);
  
    try {
      const result = await authService.signUp(formData);
      
      toast.success(result.message || "Unknown server error");        
      setTimeout(() => {
        navigate(`/login`);
      }, 3000);
    } catch (error) {
      toast.error(error.message || `Something went wrong. Please try again.`);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

    
    
  return (
    <div className="login-wrapper">

      <Loader show={loading} message="Authenticating, please wait..." />

      <div className="login-card">
        
        {/* Logo */}
        <div className="logo-container">
          <img src="/images/logo.png" alt="Logo" />
        </div>

        <p className="subtitle">Create New Account</p>

        {/* Form */}
        <form method="post" onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              name="fullName"
              placeholder="Enter your full name"
              value={formData.fullName}
              onChange={handleChange}
              required
            />
          </div>

          
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="emailAddress"
              placeholder="Enter your email"
              value={formData.emailAddress}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Mobile Number</label>
            <input
              type="text"
              name="mobileNumber"
              placeholder="Mobile with country code"
              value={formData.mobileNumber}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="login-btn">
            Register
          </button>

          <p className="register-text">
            I already have an account?{" "}
            <a href="/login">Login Instead</a>
          </p>
        </form>
      </div>
    </div>
  );
};

export default RegisterUser;